"use client";
import r, { forwardRef as f } from "react";
import { useStoryblokState as m } from "./client.mjs";
import a from "./storyblok-component.mjs";
const S = f(
  ({ story: t, bridgeOptions: o, ...e }, n) => (typeof t.content == "string" && (t.content = JSON.parse(t.content)), t = m(t, o), /* @__PURE__ */ r.createElement(a, { ref: n, blok: t.content, ...e }))
);
export {
  S as default
};
